import getConfig from 'next/config';

// Read at call time so a test mocking `next/config` can flip the setting.
export const isEmailSignInShown = (): boolean => Boolean(getConfig().publicRuntimeConfig.showEmailSignIn);
